/*
  Hush v11 — Product: sticky add-to-cart bar (mobile only).

  Shows a fixed bottom bar whenever the real Add-to-cart button is out
  of view on ≤990px. The bar's button clicks the real submit, so Dawn's
  product-form.js AJAX + cart drawer do the work — no second form.
  Price + sold-out state mirror the live elements via MutationObserver,
  so they stay correct after a variant change.
*/
(function () {
  'use strict';

  function once(el, key, fn) {
    if (el.__hv && el.__hv[key]) return;
    el.__hv = el.__hv || {};
    el.__hv[key] = true;
    fn(el);
  }

  function init() {
    document.querySelectorAll('.hv-pdp__sticky[data-submit-id]').forEach(function (b) { once(b, 'bar', setup); });
    document.querySelectorAll('.hv-pdp[data-sticky="auto"]').forEach(function (s) { once(s, 'sticky', setupStickyBuy); });
    document.querySelectorAll('.hv-pdp').forEach(function (s) { once(s, 'more', setupShowMore); });
  }
  // Theme Editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:load', init);

  // Desktop gallery: "Show all N photos" reveals the tiles past the cut-off.
  function setupShowMore(section) {
    var col = section.querySelector('.hv-pdp__media-col.is-collapsed');
    var btn = section.querySelector('.hv-pdp__more');
    if (!col || !btn) return;
    btn.addEventListener('click', function () {
      col.classList.remove('is-collapsed');
      btn.setAttribute('aria-expanded', 'true');
    });
  }

  // Desktop buy column, "Smart" mode.
  // Fits on screen → plain top pin. Taller than the window → follow the
  // scroll: scrolling down, the column moves with the page until its END
  // is in view, then pins there; scrolling up, it moves until its TOP
  // (title) is under the header, then pins there. Between those two
  // states it rides along with the page (position: relative + a frozen
  // offset), so nothing ever jumps and nothing is ever hidden.
  function setupStickyBuy(section) {
    var buy = section.querySelector('.hv-pdp__buy');
    var mediaCol = section.querySelector('.hv-pdp__media-col');
    if (!buy || !mediaCol) return;
    var desktop = window.matchMedia('(min-width: 991px)');
    var GAP = 24;
    var mode = '';            // 'fit' | 'top' | 'bottom' | 'free'
    var lastY = window.scrollY;
    var baseTop = 116;        // header + 20, refreshed in readBase()

    function readBase() {
      var h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hush-header-h'));
      baseTop = (isNaN(h) ? 96 : h) + 20;
    }

    function setMode(next, offset) {
      mode = next;
      if (next === 'free') {
        buy.style.position = 'relative';
        buy.style.top = Math.max(0, offset) + 'px';
      } else if (next === 'bottom') {
        buy.style.position = '';
        buy.style.top = (window.innerHeight - buy.offsetHeight - GAP) + 'px';
      } else {                 // 'fit' | 'top' → stylesheet sticky (top: header + 20)
        buy.style.position = '';
        buy.style.top = '';
      }
    }

    function update() {
      var y = window.scrollY;
      var scrollDelta = y - lastY;      // +down / -up, this frame
      var dir = scrollDelta > 0 ? 1 : (scrollDelta < 0 ? -1 : 0);
      lastY = y;
      if (!desktop.matches) { if (mode !== 'fit') setMode('fit'); return; }
      var h = buy.offsetHeight;
      var vh = window.innerHeight;
      if (h + baseTop + GAP <= vh) { if (mode !== 'fit') setMode('fit'); return; }

      var r = buy.getBoundingClientRect();
      var rowTop = mediaCol.getBoundingClientRect().top; // the column's in-flow top
      // On a direction reversal the old pin held the column through this
      // frame's scroll. If it was actually engaged, release it where it
      // *would* be had it ridden with the page, so nothing sticks or drifts.
      if (dir > 0) {
        if (mode === 'bottom') return;
        if (r.bottom <= vh - GAP + 0.5) setMode('bottom');
        else if (mode !== 'free') {
          var engagedTop = mode === 'top' && r.top <= baseTop + 0.5;
          setMode('free', r.top - rowTop - (engagedTop ? scrollDelta : 0));
        }
      } else if (dir < 0) {
        if (mode === 'top') return;
        if (r.top >= baseTop - 0.5) setMode('top');
        else if (mode !== 'free') {
          var engagedBottom = mode === 'bottom' && r.bottom >= vh - GAP - 0.5;
          setMode('free', r.top - rowTop - (engagedBottom ? scrollDelta : 0));
        }
      } else {
        // No scroll (load, resize, height change): keep the pins honest.
        if (mode === 'bottom') buy.style.top = (vh - h - GAP) + 'px';
        else if (mode === '' || mode === 'fit') setMode('top');
      }
    }

    function remeasure() { readBase(); update(); }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', remeasure, { passive: true });
    window.addEventListener('load', remeasure);
    if (desktop.addEventListener) desktop.addEventListener('change', remeasure); else desktop.addListener(remeasure);
    // Column height (pickup availability loads async, variant swaps) and
    // header height (fonts, nav wrap) both move the pin points.
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(remeasure);
      ro.observe(buy);
      document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) { ro.observe(el); });
    }
    remeasure();
  }

  function setup(bar) {
    var submit = document.getElementById(bar.dataset.submitId);
    if (!submit) return;

    var btn = bar.querySelector('.hv-pdp__sticky-btn');
    var priceOut = bar.querySelector('.hv-pdp__sticky-price');
    var sectionId = bar.id.replace('HvSticky-', '');
    var priceEl = document.getElementById('price-' + sectionId);
    var mq = window.matchMedia('(max-width: 990px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hideTimer = null;

    // Mirror sold-out state from the real button.
    function syncButton() {
      var dis = !!submit.disabled;
      btn.disabled = dis;
      btn.textContent = dis ? (btn.dataset.soldout || 'Sold out') : (btn.dataset.label || 'Add to cart');
    }
    new MutationObserver(syncButton).observe(submit, { attributes: true, attributeFilter: ['disabled'] });

    // Mirror price after VariantSelects.renderProductInfo swaps it.
    function syncPrice() {
      if (!priceEl || !priceOut) return;
      var p = priceEl.querySelector('.price-item--regular') || priceEl.querySelector('.price-item');
      if (p) priceOut.textContent = p.textContent.trim();
    }
    if (priceEl) {
      new MutationObserver(syncPrice).observe(priceEl, { childList: true, subtree: true, characterData: true });
    }

    function show(visible) {
      if (visible) {
        clearTimeout(hideTimer);
        bar.hidden = false;
        bar.setAttribute('aria-hidden', 'false');
        if (reduce) {
          bar.classList.add('is-visible');
        } else {
          requestAnimationFrame(function () { bar.classList.add('is-visible'); });
        }
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        if (reduce) {
          bar.hidden = true;
        } else {
          hideTimer = setTimeout(function () {
            if (!bar.classList.contains('is-visible')) bar.hidden = true;
          }, 240);
        }
      }
    }

    // Visible on mobile whenever the real button is off-screen (above or below).
    // Synchronous check via getBoundingClientRect so the bar is correct on
    // load (and after resize/scroll) without waiting for an observer tick;
    // IntersectionObserver keeps it in sync cheaply after that.
    function update() {
      if (!mq.matches) { show(false); return; }
      var r = submit.getBoundingClientRect();
      var inView = r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
      show(!inView);
    }
    var io = new IntersectionObserver(function () { update(); }, { threshold: 0 });
    io.observe(submit);
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    function onMq() { update(); }
    if (mq.addEventListener) mq.addEventListener('change', onMq); else mq.addListener(onMq);
    update();

    btn.addEventListener('click', function () {
      if (submit.disabled) return;
      submit.click(); // triggers the form submit → product-form.js → cart drawer
    });

    syncButton();
    syncPrice();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
